export default function NotFound() {
  const location = useLocation();
  
  return (
    <div className="min-h-screen bg-background-50 font-body flex flex-col items-center justify-center text-center px-4">
      <h1 className="absolute bottom-0 text-7xl sm:text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
          <i className="ri-emotion-sad-line text-4xl text-primary-400"></i>
        </div>
        <h1 className="text-xl sm:text-2xl font-bold text-foreground-950 mt-4 md:mt-6">Página não encontrada</h1>
        <p className="mt-2 text-sm text-foreground-400 font-mono break-all">{location.pathname}</p>
        <p className="mt-4 text-sm md:text-base text-foreground-500">Ops! Essa página não existe ou foi movida.</p>
        <a href="/" className="mt-6 inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white text-sm font-bold px-5 py-2.5 rounded-full transition-colors cursor-pointer whitespace-nowrap">
          <i className="ri-home-4-line"></i> Voltar para o início
        </a>
      </div>
    </div>
  );
}